import {
  Button as MuiButton,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  TextField,
} from "@mui/material";
import React from "react";
import { Field, FieldArray } from "formik";
import styled from "styled-components/macro";
import { spacing } from "@mui/system";

export const FieldAppID = () => (
  <Field name="app_id">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="App ID"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldName = () => (
  <Field name="name">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Name"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldAPIKey = () => (
  <Field name="api_key">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="API key"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldDeeplinkOpenApp = () => (
  <Field name="deeplink_open_app">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Deeplink open app"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldStorageBucket = () => (
  <Field name="storage_bucket">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Storage bucket"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldDatabaseUrl = () => (
  <Field name="database_url">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Database URL"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldHost = () => (
  <Field name="host">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Host"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldPort = () => (
  <Field name="port">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Port"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldFirebaseServiceAccountJSON = () => (
  <Field name="firebase_service_account_json">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Firebase service account JSON"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldGameServers = () => (
  <Field name="game_servers">
    {({
      field: { name, value, onChange, onBlur },
      meta: { touched, error },
    }) => (
      <TextField
        name={name}
        label="Game servers"
        value={value}
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        onBlur={onBlur}
        onChange={onChange}
      />
    )}
  </Field>
);

export const FieldIsSecure = () => (
  <Field name="is_secure">
    {({ field: { name, value, onChange } }) => (
      <FormGroup row>
        <FormControlLabel
          control={
            <Switch
              name={name}
              color="primary"
              checked={value}
              onChange={onChange}
            />
          }
          label="Is secure?"
        />
      </FormGroup>
    )}
  </Field>
);

const Button = styled(MuiButton)(spacing);

export const FieldConfigVersions = ({ value }) => (
  <FieldArray
    name="config_versions"
    render={(arrayHelpers) => {
      return (
        <Grid container spacing={2}>
          {value &&
            value.map((version, index) => (
              <React.Fragment key={index}>
                <Grid item xs={5}>
                  <Field name={`config_versions.${index}.key`}>
                    {({
                      field: { name, value, onChange, onBlur },
                      meta: { touched, error },
                    }) => (
                      <TextField
                        type="text"
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label="Version"
                        error={Boolean(touched && error)}
                        fullWidth
                        helperText={touched && error}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={5}>
                  <Field name={`config_versions.${index}.value`}>
                    {({
                      field: { name, value, onChange, onBlur },
                      meta: { touched, error },
                    }) => (
                      <TextField
                        type="text"
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        label="Value"
                        error={Boolean(touched && error)}
                        fullWidth
                        helperText={touched && error}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    onClick={() => arrayHelpers.remove(index)}
                    my={2}
                    fullWidth
                  >
                    Remove
                  </Button>
                </Grid>
              </React.Fragment>
            ))}
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={() =>
                arrayHelpers.insert(value.length, { key: "", value: "" })
              }
              fullWidth
            >
              Add version
            </Button>
          </Grid>
        </Grid>
      );
    }}
  />
);
